import { Link, LinkProps } from 'react-router-dom';

interface Props extends LinkProps {
  condition: Boolean;
}

export const ConditionalLink = ({ condition, children, to }: Props) => {
  return condition ? (
    <Link to={to} state={{ back: window.location.pathname }}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};
